import React from 'react'

import ChoiceNumberButton from '@components/Button/ChoiceNumberButton'

type OmrChoiceNumbersProps = {
  questionNumber: number
  choice: number
  setChoice: (choice: number) => void
  viewResultMode?: boolean
  answer?: number
  questionsCount?: number
}

const OmrChoiceNumbers: React.FC<OmrChoiceNumbersProps> = ({
  questionNumber,
  choice,
  setChoice,
  viewResultMode,
  answer,
  questionsCount,
}) => {
  const i = questionNumber
  const is5nth = i % 5 === 0 && i !== questionsCount

  return (
    <div
      className={`c-no flex mt-5 px-6 w-[200px] justify-between items-center text-2xl ${
        is5nth ? 'mb-5' : 'mb-0'
      }`}
    >
      {[1, 2, 3, 4, 5].map((number) => {
        const className = (() => {
          let _className = ''
          if (number === choice) _className = 'border-cbtLayout text-cbtLayout bg-D2DDED'
          if (viewResultMode && number === answer) {
            _className = 'text-primary-text border-bosalpim'
          }
          return _className
        })()
        return (
          <ChoiceNumberButton
            key={number}
            choiceNumber={number}
            questionNumber={questionNumber}
            afterChoiceBorderTextBgStyle={className}
            onClick={setChoice}
            isInQuestionArea={false}
          />
        )
      })}
    </div>
  )
}

export default React.memo(OmrChoiceNumbers)
